export default "__VITE_ASSET__BCPWEzyL__"